import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import UploadWidget from "./Components/UploadWidget";

const Skills = (props) => {
  const [UploadCount, setUploadCount] = useState(0);
  const [UploadInProgress, setUploadInProgress] = useState(false);
  const [SkillsHadError, setSkillsHadError] = useState(false);
  const [SkillEmpHadError, setSkillEmpHadError] = useState(false);
  const [SkillPosHadError, setSkillPosHadError] = useState(false);
  const [FirstDialogIsOpen, setFirstDialogIsOpen] = useState(false);
  const [SecondDialogIsOpen, setSecondDialogIsOpen] = useState(false);
  const [GenerateSkillsFor, setGenerateSkillsFor] = useState(null); //"ALL_JPA" | "JPA_WITHOUT_SKILLS" | null (no skill generation)

  var CheckFileCountTimer;

  useEffect(() => {
    CheckFileCountTimer = setInterval(updatePrevFileCount, 100);
    if (props.GenerateSkillsFor) {
      setGenerateSkillsFor(props.GenerateSkillsFor);
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateFileSize = (FileSize, Id) => {
    setTimeout(() => {
      if (FileSize <= 1) {
        document.getElementById(Id).innerHTML = translateText(
          "data_import_widget_error_non_empty"
        );
      }
    }, 100);
  };

  // this function is called after each file is uploaded inside the then promise, to
  // check the uploaded file extension and in case it is wrong (non-csv) it will set an
  // innerHTML for the error <p></p> tag with the relevant Id. FileName and ErrorElementId
  // are passed down as params to the function call and are different for each upload widget and
  // each uploaded file.
  const validateUploadedFileExtension = (FileName, ErrorElementId) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(ErrorElementId) !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(ErrorElementId).innerHTML =
          "Please upload a csv file.";
      }
    }
  };

  const updatePrevFileCount = () => {
    var Count = 0;
    for (let i = 1; i < 4; i++) {
      if (
        document.getElementById("csv-" + i + "-check") !== null &&
        document
          .getElementById("csv-" + i + "-check")
          .classList.contains("feather-check")
      ) {
        Count++;
      }
    }
    if (Count === 3) {
      clearInterval(CheckFileCountTimer);
    }
    setUploadCount(Count);
  };

  const handleUploadEnd = () => {
    setTimeout(() => {
      updatePrevFileCount();
    }, 300);
  };
  // Skills.csv file upload handler
  const uploadSkillsCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-1-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/skill/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-1-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setSkillsHadError(false);
        } else {
          setSkillsHadError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-1-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setSkillsHadError(true);
      });
  };
  // SkillEmp.csv file upload handler
  const uploadSkillEmpCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-2-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/skill-employee/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-2-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setSkillEmpHadError(false);
        } else {
          setSkillEmpHadError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-2-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setSkillEmpHadError(true);
      });
  };
  // SkillPos.csv file upload handler
  const uploadSkillPosCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-3-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/skill-position/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-3-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setSkillPosHadError(false);
        } else {
          setSkillPosHadError(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-3-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setSkillPosHadError(true);
      });
  };

  const handleCheckboxChange = (Id, GenerateSkillValue) => {
    let IsChecked = document.getElementById(Id).checked;

    if (IsChecked) {
      setGenerateSkillsFor(GenerateSkillValue);
      props.SetGenerateSkillsFor(GenerateSkillValue);
    } else {
      setGenerateSkillsFor(null);
      props.SetGenerateSkillsFor(null);
    }
  };

  return (
    <div className="simple-form">
      <section className="form-head">
        <h1>
          {translateText("skills_files")}
          <p className="opt-info">{"(" + translateText("optional") + ")"}</p>
        </h1>
      </section>
      <div className="form-body">
        <p className="info-top">
          {UploadCount +
            " " +
            translateText("of") +
            " " +
            "3 " +
            translateText("files_uploaded_successfully")}
        </p>
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadSkillsCSV()}
          Enum={"SKILL"}
          API_Name={"skill"}
          UploadHadErrors={SkillsHadError}
          SwitchErrorState={() => setSkillsHadError(!SkillsHadError)}
          Placeholder="Skills.csv"
          Id="csv-1"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setSkillsHadError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadSkillEmpCSV()}
          Enum={"SKILL_EMPLOYEE"}
          API_Name={"skill-employee"}
          UploadHadErrors={SkillEmpHadError}
          SwitchErrorState={() => setSkillEmpHadError(!SkillEmpHadError)}
          Placeholder="SkillEmp.csv"
          Id="csv-2"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setSkillEmpHadError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadSkillPosCSV()}
          Enum={"SKILL_POSITION"}
          API_Name={"skill-position"}
          UploadHadErrors={SkillPosHadError}
          SwitchErrorState={() => setSkillPosHadError(!SkillPosHadError)}
          Placeholder="SkillPos.csv"
          Id="csv-3"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setSkillPosHadError(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <section className="checkbox-row">
          <p className="row-text">{translateText("data_import_info_1")}</p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setFirstDialogIsOpen(true)}
              onMouseLeave={() => setFirstDialogIsOpen(false)}
            ></i>
            {FirstDialogIsOpen ? (
              <section className="info-popup">
                {translateText("data_import_info_3")}
              </section>
            ) : null}
            <label
              className={
                GenerateSkillsFor === "JPA_WITHOUT_SKILLS" ||
                GenerateSkillsFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() =>
                  handleCheckboxChange("checkbox-jpa", "JPA_WITHOUT_SKILLS")
                }
                type="checkbox"
                id="checkbox-jpa"
                class="blue-checkbox"
                checked={
                  props.GenerateSkillsFor === "JPA_WITHOUT_SKILLS"
                    ? true
                    : false
                }
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
        <section className="checkbox-row">
          <p className="row-text">{translateText("data_import_info_2")}</p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setSecondDialogIsOpen(true)}
              onMouseLeave={() => setSecondDialogIsOpen(false)}
            ></i>
            {SecondDialogIsOpen ? (
              <section className="info-popup">
                {translateText("data_import_info_4")}
              </section>
            ) : null}
            <label
              className={
                GenerateSkillsFor === "ALL_JPA" || GenerateSkillsFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() => handleCheckboxChange("checkbox-all", "ALL_JPA")}
                type="checkbox"
                id="checkbox-all"
                class="blue-checkbox"
                checked={props.GenerateSkillsFor === "ALL_JPA" ? true : false}
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
      </div>
    </div>
  );
};
export default Skills;
